/**
 * @file job_alert_analytics.tsx
 *
 * @fileoverview helper functions for job alert analytics events.
 */

import {
  DIMENSIONS,
  PAGE_TYPES,
  PageType,
  setEventParams,
} from '~/jobiqo/lib/analytics';
import { ANONYMOUS_USER } from '~/jobiqo/lib/auth';
import { concatenateSearchFacetLabels } from '~/jobiqo/lib/search';
import { Facet } from '~/jobiqo/models/search';
import { User } from '~/jobiqo/models/user';
import { JobAlert } from '~/jobiqo/types/types';
import { concatArrayItems } from '~/jobiqo/utils/mapper';

/**
 * Returns the dimensions for a given jobAlert.
 *
 * @param {JobAlert} jobAlert
 *   The job alert to return dimensions for.
 * @param {User} user
 *   Current user.
 * @param {Facet[]}
 *   Search facets.
 * @returns {Object}
 *   The dimensions object for this job alert.
 */
export const getjobAlertDimensions = (
  jobAlert: JobAlert | null,
  user: User | null,
  facets: Facet[],
  regions: string = '',
  pageType: PageType = PAGE_TYPES.JOB_SEARCH,
) =>
  setEventParams({
    [DIMENSIONS.entity_id]: jobAlert?.id,
    [DIMENSIONS.title]: jobAlert?.name,
    [DIMENSIONS.current_user_id]: user?.id,
    [DIMENSIONS.user_role]:
      concatArrayItems(user?.roles, 'targetId') ?? ANONYMOUS_USER,
    [DIMENSIONS.entity_type]: 'saved_searches',
    [DIMENSIONS.entity_subtype]: 'job_alert',
    [DIMENSIONS.occupations]: concatenateSearchFacetLabels(
      facets,
      'field_job_occupational_field_parents_all',
    ),
    [DIMENSIONS.employment_types]: concatenateSearchFacetLabels(
      facets,
      'field_job_employment_type',
    ),
    [DIMENSIONS.regions]: regions,
    [DIMENSIONS.page_type]: pageType,
  });
